import React, { useEffect, useState } from "react";
import './tutors.css';
import '../css/main-style.css';
import {getData, postData} from '../middleware/apiMiddleware';
import { getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';
import { useNavigate, useParams } from "react-router-dom";

import TutorReordering from '../components/TutorReordering'
import TutorBasic from '../components/TutorBasic'

export default function Tutors() {
	const navigate = useNavigate();
	

	const [toggleTag, setToggleTag] = useState((getGeneralStorage('tutorsToggle') ?? "tutors"));
	const processToggleTag = (toggle) =>{
		setGeneralStorage('tutorsToggle', toggle);
		setToggleTag(toggle)
	}
	
	
	return (<div>
		<div style={{margin:"10px", padding:"10px"}}>
			<div className="optionToggleHolder">
				<div className="optionToggle" style={(toggleTag=="tutors")?{background:"#808080", color:"white"} : {cursor:"pointer"}} onClick={()=>processToggleTag("tutors")}>Tutors</div>
				<div className="optionToggle" style={(toggleTag=="reordering")?{background:"#808080", color:"white"} : {cursor:"pointer"}} onClick={()=>processToggleTag("reordering")}>Reodering</div>
			</div>
		</div>
		
	
		<div>
			{
				(toggleTag=="tutors") && (<TutorBasic />)
			}
			{
				(toggleTag=="reordering") && (<TutorReordering />)
			}
		
		</div>
	
	
	</div>);
}